<div class="container">
	<div class="row">
		<div class="col-lg-6">
			<div class="panel">
				<div class="heading">Add Organization</div>
				<div class="content">
					<div class="mb-3">
						<label>Organization name</label>
						<input [(ngModel)]="addorganization.name" type="text" class="form-control">
					</div>
					<div class="mb-3">
						<app-action-button [action]="AddOrganization" [context]="this" processing="Adding..." complete="Organization added" btnClass="green wide">Add
							Organization</app-action-button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="panel">
				<div class="heading">Add User to Organization</div>
				<div class="content">
					<div class="mb-3">
						<label>Organization name</label>
						<select [(ngModel)]="adduser.organization" class="form-control">
							@for (org of organizations; track org) {
							<option [ngValue]="org">{{org.name}}</option>
							}
						</select>
					</div>
					<div class="mb-3">
						<label for="email">Email address</label>
						<input [(ngModel)]="adduser.email" name="email" type="email" id="email" class="form-control">
					</div>
					<div class="mb-3">
						<label>Password</label>
						<input [(ngModel)]="adduser.password" type="password" class="form-control">
					</div>
					<div class="mb-3">
						<label>Role</label>
						<select [(ngModel)]="adduser.role" class="form-control">
							<option value="orgadmin">Organization Administrator</option>
							<option value="user">User</option>
							<option value="readonly">Read Only</option>
						</select>
					</div>
					<div class="mb-3">
						<app-action-button [action]="AddUser" [context]="this" processing="Adding..." complete="User added" btnClass="green wide">Add User</app-action-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>